import { Flex } from "antd";
import { AlertCard } from "@libertify/ui";
import { useTranslate } from "#src/hooks";
import { UpgradeButton } from "components/UpgradeButton";

export function QuotaAlert() {
  const t = useTranslate();

  return (
    <Flex vertical gap={12} style={{ width: "100%" }}>
      <AlertCard
        type="warning"
        title={t("quota.projectQuotaReached")}
        description={t("quota.projectQuotaReachedDescription")}
      />
      <UpgradeButton buttonLocation="quota_alert" />
    </Flex>
  );
}
